import * as React from "react";
const SvgArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17.85 32.69", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.41 15.28L2.56.44A1.5 1.5 0 0 0 .44 2.56l13.78 13.79L.44 30.13a1.5 1.5 0 0 0 2.12 2.12l14.82-14.82a1.51 1.51 0 0 0 .03-2.15z" }));
export default SvgArrow;
